import React, { useMemo } from "react";

export default function PreviewNav({
  config,
  device = "desktop",
  onReserveClick,
}) {
  // ✅ Never crash if config is null
  const theme = config?.theme || {};
  const branding = config?.branding || {};
  const hero = branding?.hero || {};
  const logo = branding?.logo || {};

  const primary = theme?.primary || "#9df03d";
  const onPrimary = theme?.onPrimary || "#05070a";

  const isMobile = device === "mobile";

  // ✅ Support multiple possible logo keys (for safety)
  const showLogo = logo?.showLogo !== false;

  const logoUrl =
    logo?.lightLogoUrl ||
    logo?.logoUrl ||
    branding?.logoUrl || // legacy fallback if exists
    "";

  const titleFallback = hero?.headline || "Restaurant";

  const dims = useMemo(() => {
    const width = Number(logo?.width ?? (isMobile ? 140 : 170));
    const height = Number(logo?.height ?? (isMobile ? 44 : 54));

    return {
      padY: isMobile ? 10 : 12,
      padX: isMobile ? 12 : 18,
      navH: isMobile ? 56 : 68,
      logoW: Math.min(Math.max(width, 90), 320),
      logoH: Math.min(Math.max(height, 34), 90),
      btnPad: isMobile ? "10px 14px" : "11px 18px",
      btnFont: isMobile ? 12 : 13,
    };
  }, [isMobile, logo?.width, logo?.height]);

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 60,
        height: dims.navH,
        display: "flex",
        alignItems: "center",
        padding: `${dims.padY}px ${dims.padX}px`,
        // ✅ glass overlay merging with hero like booking engine
        background:
          "linear-gradient(180deg, rgba(0,0,0,0.62), rgba(0,0,0,0.28), rgba(0,0,0,0))",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        {showLogo && logoUrl ? (
          <img
            src={logoUrl}
            alt="Logo"
            style={{
              width: dims.logoW,
              height: dims.logoH,
              objectFit: "contain",
              filter: "drop-shadow(0 10px 18px rgba(0,0,0,0.35))",
            }}
          />
        ) : (
          <div
            style={{
              color: "#fff",
              fontWeight: 950,
              fontSize: isMobile ? 14 : 16,
              letterSpacing: -0.2,
              textShadow: "0 12px 26px rgba(0,0,0,0.35)",
            }}
          >
            {titleFallback}
          </div>
        )}
      </div>

      <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
        {/* Accent dot */}
        <span
          style={{
            width: 10,
            height: 10,
            borderRadius: 999,
            background: primary,
            boxShadow: `0 0 0 6px rgba(157,240,61,0.12), 0 0 22px rgba(157,240,61,0.30)`,
            marginRight: 12,
          }}
        />

        <button
          type="button"
          onClick={() => onReserveClick?.()}
          style={{
            border: "none",
            cursor: "pointer",
            borderRadius: 999,
            padding: dims.btnPad,
            fontWeight: 950,
            fontSize: dims.btnFont,
            color: onPrimary,
            background: `linear-gradient(180deg, ${primary}, rgba(0,0,0,0.18))`,
            boxShadow:
              "0 18px 44px rgba(0,0,0,0.22), 0 0 0 1px rgba(255,255,255,0.16) inset",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
          }}
        >
          Reserve
        </button>
      </div>
    </div>
  );
}
